import {initLucide} from './lucide';

(function(){
	document.addEventListener('DOMContentLoaded', function() {
		initLucide();
		initMenuToggle();
		initMegaMenu();
		initStickyHeader();
		initThemeToggle();
		initSearch();
		initAccordion();
		initScreenshotModal();
		initFilterNaviToggle();
		initTestimonialSlider();
		initVideoPlayers();
		initStepsTracker();
		initTabs();
		initModalbox();
		initSearchAutocomplete();
		initFilterDrawer();
		initMobileLangSwitcher();
		initEmptyHeroLinks();
		initExternalLinks();
		initGtmTracking();
		initFormTracking();
		initCatalogEntry();
	});

	document.addEventListener('DOMContentLoaded', () => {
		const cards = document.querySelectorAll('.card-item');

		cards.forEach(card => {
			const links = card.querySelectorAll('a');

			if (links.length === 1) {
				card.classList.add('has-single-link');
			}
		});
	});

})();

// Menu Toggle
function initMenuToggle() {
	const btn = document.getElementById('menu-toggle');
	const menu = document.getElementById('site-menu');
	const iconBurger = document.getElementById('icon-burger');
	const iconClose = document.getElementById('icon-close');
	const focusableSelectors = 'a[href], button:not([disabled]), input, select, textarea';

	if(!btn || !menu){
		return;
	}

	// Cleanup: Entferne overflow-hidden beim Page-Load (falls durch Reload noch gesetzt)
	document.documentElement.classList.remove('overflow-hidden');
	document.body.classList.remove('overflow-hidden');

	function openMenu(){
		menu.classList.add('menu-open');

		// SVG classList funktioniert anders, daher setAttribute verwenden
		iconBurger.setAttribute('class', 'h-6 w-6 menu-icon-hide');
		iconClose.setAttribute('class', 'h-6 w-6 menu-icon-show');
		btn.setAttribute('aria-expanded', 'true');
		btn.setAttribute('aria-label', (window.caigosI18n?.closeMenu) || 'Menü schließen');

		document.documentElement.classList.add('overflow-hidden');
		document.body.classList.add('overflow-hidden');

		const firstFocusable = menu.querySelector(focusableSelectors);
		if(firstFocusable){
			firstFocusable.focus();
		}
	}

	function closeMenu(){
		menu.classList.remove('menu-open');

		// SVG classList funktioniert anders, daher setAttribute verwenden
		iconBurger.setAttribute('class', 'h-6 w-6 menu-icon-show');
		iconClose.setAttribute('class', 'h-6 w-6 menu-icon-hide');
		btn.setAttribute('aria-expanded', 'false');
		btn.setAttribute('aria-label', (window.caigosI18n?.openMenu) || 'Menü öffnen');

		document.documentElement.classList.remove('overflow-hidden');
		document.body.classList.remove('overflow-hidden');

		// Mobile: Alle Slide-Ebenen zurücksetzen
		const subMenus = document.querySelectorAll('.sub.active');
		const tabContents = document.querySelectorAll('.navi-tabs-content.active');
		const tabs = document.querySelectorAll('.tab.active');

		subMenus.forEach(sub => sub.classList.remove('active'));
		tabContents.forEach(content => content.classList.remove('active'));
		tabs.forEach(tab => tab.classList.remove('active'));

		btn.focus();
	}

	function isOpen(){
		return menu.classList.contains('menu-open');
	}

	btn.addEventListener('click', function(e){
		e.stopPropagation();

		if(isOpen()){
			closeMenu();
		} else {
			openMenu();
		}
	});

	document.addEventListener('keydown', function(e){
		if(e.key === 'Escape' && isOpen()){
			closeMenu();
		}
	});

	window.addEventListener('resize', function(){
		const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
		if(isDesktop && isOpen()){
			closeMenu();
		}
	});
}

// Mega Menu (Tab Switching & Mobile Navigation)
function initMegaMenu() {
	const isMobile = () => window.innerWidth < 1024;
	const tabNavItems = document.querySelectorAll('.navi-tabs-navi li');
	const moreTabItems = document.querySelectorAll('.more-tab-links li[data-tab]');
	const allTabNavItems = [...tabNavItems, ...moreTabItems];
	const tabContents = document.querySelectorAll('.navi-tabs-content .tab');

	if(!tabNavItems.length || !tabContents.length){
		return;
	}

	// Desktop: Hover-basiertes Tab-Switching
	if(tabNavItems[0] && !isMobile()){
		tabNavItems[0].classList.add('active');
	}

	allTabNavItems.forEach(navItem => {
		// Desktop: Hover
		navItem.addEventListener('mouseenter', function(){
			if(isMobile()) return;

			const tabId = this.dataset.tab;
			if(!tabId) return;

			allTabNavItems.forEach(item => item.classList.remove('active'));
			this.classList.add('active');

			tabContents.forEach(tab => tab.classList.remove('active'));

			const activeTab = document.querySelector(`.tab[data-tab-content="${tabId}"]`);
			if(activeTab){
				activeTab.classList.add('active');
			}
		});

		// Mobile: Click auf Tab-Navigation zeigt Content
		navItem.addEventListener('click', function(e){
			if(!isMobile()) return;

			const tabId = this.dataset.tab;
			if(!tabId) return;

			e.preventDefault();
			e.stopPropagation();

			const tabContentContainer = this.closest('.navi-tabs').querySelector('.navi-tabs-content');
			const activeTab = tabContentContainer.querySelector(`.tab[data-tab-content="${tabId}"]`);

			if(activeTab){
				// Alle Tabs ausblenden
				tabContents.forEach(tab => tab.classList.remove('active'));
				// Aktiven Tab anzeigen
				activeTab.classList.add('active');
				// Content Container sliden
				tabContentContainer.classList.add('active');
			}
		});
	});

	// Mobile: Click auf Hauptmenü-Item (Produkte) öffnet Sub-Menu
	const megaMenuItems = document.querySelectorAll('.has-mega-menu > a');

	megaMenuItems.forEach(item => {
		item.addEventListener('click', function(e){
			if(!isMobile()) return;

			e.preventDefault();

			const subMenu = this.nextElementSibling;

			if(subMenu && subMenu.classList.contains('sub')){
				subMenu.classList.add('active');
			}
		});
	});

	// Mobile: Back Buttons
	const backButtons = document.querySelectorAll('.mobile-back-btn');
	backButtons.forEach(btn => {
		btn.addEventListener('click', function(){
			const backTo = this.dataset.backTo;

			if(backTo === 'main'){
				// Von Tab-Übersicht zurück zum Hauptmenü
				const subMenu = this.closest('.sub');
				if(subMenu){
					subMenu.classList.remove('active');
				}
			} else if(backTo === 'tabs'){
				// Von Content zurück zur Tab-Übersicht
				const tabContentContainer = this.closest('.navi-tabs-content');
				if(tabContentContainer){
					tabContentContainer.classList.remove('active');
					// Alle Tabs ausblenden
					tabContents.forEach(tab => tab.classList.remove('active'));
				}
			}
		});
	});
}

// Sticky Header
function initStickyHeader() {
	const fixedHeader = document.getElementById('fixed-header');
	const actionMenu = document.getElementById('action-menu');

	const MIN_WIDTH = 900; // Sticky erst ab dieser Breite aktiv
	const OFFSET_PX = 0;   // Optionaler Feintuning-Offset (+ = später stuck, - = früher)
	let thresholdPx = 0;
	let lastStuck = null;

	if(!fixedHeader){
		console.warn('Sticky: #fixed-header nicht gefunden.');
		return;
	}

	function computeThreshold(){
		if(actionMenu){
			// outerHeight inklusive margin, wenn vorhanden
			const rect = actionMenu.getBoundingClientRect();
			const style = window.getComputedStyle(actionMenu);
			const marginTop = parseFloat(style.marginTop) || 0;
			const marginBottom = parseFloat(style.marginBottom) || 0;

			thresholdPx = rect.height + marginTop + marginBottom + OFFSET_PX;
		} else {
			thresholdPx = OFFSET_PX;
		}
	}

	function updateSticky(){
		if(window.innerWidth < MIN_WIDTH){
			if(lastStuck !== false){
				fixedHeader.classList.remove('stuck');
				lastStuck = false;
			}
			return;
		}

		const shouldStick = window.scrollY >= thresholdPx;

		if(shouldStick){
			if(lastStuck !== true){
				fixedHeader.classList.add('stuck');
				lastStuck = true;
			}
		} else {
			if(lastStuck !== false){
				fixedHeader.classList.remove('stuck');
				lastStuck = false;
			}
		}
	}

	window.addEventListener('scroll', updateSticky, {passive:true});
	window.addEventListener('resize', function(){
		computeThreshold();
		updateSticky();
	}, {passive:true});

	computeThreshold();
	updateSticky();
}

// Theme Toggle
function initThemeToggle() {
	const html = document.documentElement;
	const btn = document.getElementById('theme-toggle');
	const btnMobile = document.getElementById('theme-toggle-mobile');

	if(!btn && !btnMobile){
		console.warn('Theme toggle not found');
		return;
	}

	function setTheme(theme){
		html.classList.toggle('dark', theme === 'dark');
		html.dataset.theme = theme;
		localStorage.setItem('theme', theme);
		updateIcon(theme);
	}

	function updateIcon(theme){
		// Get fresh reference to the icon elements (they get replaced by Lucide)
		const iconElement = document.getElementById('theme-icon');
		const iconElementMobile = document.querySelector('.theme-icon-mobile');

		// Show moon in light mode (to switch TO dark)
		// Show sun in dark mode (to switch TO light)
		const newIcon = theme === 'dark' ? 'sun' : 'moon';

		if(iconElement){
			iconElement.setAttribute('data-lucide', newIcon);
		}
		if(iconElementMobile){
			iconElementMobile.setAttribute('data-lucide', newIcon);
		}

		// Re-initialize Lucide to render the new icon
		if(window.initLucide){
			window.initLucide();
		}
	}

	function toggleTheme(){
		const current = html.dataset.theme === 'dark' ? 'light' : 'dark';
		setTheme(current);
	}

	if(btn){
		btn.addEventListener('click', toggleTheme);
	}
	if(btnMobile){
		btnMobile.addEventListener('click', toggleTheme);
	}

	// Initialer Zustand
	updateIcon(html.dataset.theme);

	// Optional: Wenn sich System-Setting ändert (nur wenn kein manuelles Setting existiert)
	window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
		if(!localStorage.getItem('theme')){
			setTheme(e.matches ? 'dark' : 'light');
		}
	});
}

// Accordion
function initAccordion() {
	const accordionBlocks = document.querySelectorAll('.accordion-block');

	accordionBlocks.forEach(accordion => {
		const triggers = accordion.querySelectorAll('.accordion-trigger');

		triggers.forEach(trigger => {
			trigger.addEventListener('click', function() {
				const item = this.closest('.accordion-item');
				const content = item.querySelector('.accordion-content');
				const isExpanded = this.getAttribute('aria-expanded') === 'true';

				// Toggle this item
				if (isExpanded) {
					// Close
					this.setAttribute('aria-expanded', 'false');
					item.classList.remove('is-open');

					// Slide up
					const contentHeight = content.scrollHeight;
					content.style.height = contentHeight + 'px';

					requestAnimationFrame(() => {
						content.style.height = '0';
					});
				} else {
					// Open
					this.setAttribute('aria-expanded', 'true');
					item.classList.add('is-open');

					// Slide down
					const contentHeight = content.scrollHeight;
					content.style.height = '0';

					requestAnimationFrame(() => {
						content.style.height = contentHeight + 'px';
					});

					// Reset height after transition for responsive behavior
					content.addEventListener('transitionend', function handler() {
						if (item.classList.contains('is-open')) {
							content.style.height = 'auto';
						}
						content.removeEventListener('transitionend', handler);
					});
				}
			});
		});
	});

	// Initialize Lucide icons for accordion
	if (typeof initLucide === 'function') {
		initLucide();
	}
}

// Filter Navigation Toggle
function initFilterNaviToggle() {
	const filterNaviList = document.querySelectorAll('.filter-navi');

	if (filterNaviList.length === 0) {
		return;
	}

	// Add click handlers to all filter-open elements (from all filter-navi containers)
	const toggleButtons = document.querySelectorAll('.filter-navi .filter-open');

	toggleButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			const listItem = this.closest('li');

			if (listItem) {
				listItem.classList.toggle('is-open');
			}
		});
	});

	// Add click handlers to all filter-head elements (from all filter-navi containers)
	const filterHeads = document.querySelectorAll('.filter-navi .filter-head');

	filterHeads.forEach(head => {
		head.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			const listItem = this.closest('li');
			if (!listItem) return;

			// Check if this is the "All Products" filter
			if (this.hasAttribute('data-filter-all')) {
				// Uncheck all category filters
				const allCheckboxes = document.querySelectorAll('.product-cat-filter');
				allCheckboxes.forEach(checkbox => {
					checkbox.checked = false;
				});

				// Remove active class from all filter items
				const allItems = document.querySelectorAll('.filter-navi li');
				allItems.forEach(item => {
					item.classList.remove('active');
				});

				// Add active class to "All Products"
				listItem.classList.add('active');

				// Trigger change event to reload with no filters
				const firstCheckbox = document.querySelector('.product-cat-filter');
				if (firstCheckbox) {
					firstCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
				}

				return;
			}

			// Check if this is a clickable filter-head (no children, acts as checkbox)
			if (this.classList.contains('filter-head-clickable')) {
				const termId = this.dataset.termId;
				const checkbox = listItem.querySelector('#term-' + termId);

				if (checkbox) {
					// Toggle the checkbox
					checkbox.checked = !checkbox.checked;

					// Kategorien exklusiv: alle anderen deselektieren
					if (checkbox.checked) {
						document.querySelectorAll('.product-cat-filter').forEach(function(cb) {
							if (cb !== checkbox) {
								cb.checked = false;
								const li = cb.closest('li');
								if (li) li.classList.remove('active');
							}
						});
					}

					// Toggle active class on list item
					listItem.classList.toggle('active', checkbox.checked);

					// Trigger change event to fire AJAX filter
					checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
			} else {
				// Regular filter-head with children - toggle the dropdown
				const filterOpen = listItem.querySelector('.filter-open');
				if (filterOpen) {
					filterOpen.click();
				}
			}
		});
	});
}

// Testimonial Slider
function initTestimonialSlider() {
	const testimonialSlider = document.querySelector('.testimonial-slider');

	if (!testimonialSlider) {
		return;
	}

	const realCount = parseInt(testimonialSlider.dataset.realCount) || 3;

	// Build custom pagination HTML
	const paginationEl = testimonialSlider.querySelector('.swiper-pagination');

	function updateBullets(activeIndex) {
		const mapped = activeIndex % realCount;
		const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
		bullets.forEach(function (b, i) {
			b.classList.toggle('swiper-pagination-bullet-active', i === mapped);
		});
	}

	// Initialize Swiper
	const swiper = new Swiper('.testimonial-slider', {
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 16,
		loop: true,
		initialSlide: 1,

		// Navigation arrows
		navigation: {
			nextEl: '.testimonial-slider .swiper-button-next',
			prevEl: '.testimonial-slider .swiper-button-prev',
		},

		// Disable built-in pagination – we handle it ourselves
		pagination: false,

		// Responsive breakpoints
		breakpoints: {
			640: {
				slidesPerView: 1.2,
				spaceBetween: 12,
			},
			768: {
				slidesPerView: 1.5,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
		},

		on: {
			init: function () {
				if (typeof initLucide === 'function') {
					initLucide();
				}
			},
			slideChange: function (s) {
				updateBullets(s.realIndex);
			}
		}
	});

	// Render bullets manually
	let bulletsHTML = '';
	for (let i = 0; i < realCount; i++) {
		bulletsHTML += '<span class="swiper-pagination-bullet" data-index="' + i + '"></span>';
	}
	paginationEl.innerHTML = bulletsHTML;
	updateBullets(swiper.realIndex);

	// Click handler for bullets
	paginationEl.addEventListener('click', function (e) {
		const bullet = e.target.closest('.swiper-pagination-bullet');
		if (bullet) {
			swiper.slideToLoop(parseInt(bullet.dataset.index));
		}
	});
}

// Screenshot Modal
function initScreenshotModal() {
	let modal = null;
	let currentIndex = -1;
	let allImages = [];

	// Collect all zoomable images on the page
	function collectImages() {
		allImages = [];
		const cardItems = document.querySelectorAll('.card-item');
		cardItems.forEach(card => {
			const img = card.querySelector('.card-image img');
			const zoomBtn = card.querySelector('.btn-screenshot');
			if (img && zoomBtn) {
				allImages.push({
					src: img.dataset.fullSrc || img.src,
					alt: img.alt || ''
				});
			}
		});
	}

	// Create modal element
	function createModal() {
		const modalEl = document.createElement('div');
		modalEl.className = 'screenshot-modal';
		modalEl.innerHTML = `
			<div class="screenshot-modal-backdrop"></div>
			<div class="screenshot-modal-content">
				<button class="screenshot-modal-close" aria-label="Close">
					<div class="icon"><i data-lucide="x"></i></div>
				</button>
				<button class="screenshot-modal-nav screenshot-modal-prev" aria-label="Previous">
					<div class="icon"><i data-lucide="chevron-left"></i></div>
				</button>
				<div class="screenshot-modal-image-wrapper">
					<img src="" alt="" class="screenshot-modal-image" />
					<div class="screenshot-modal-counter"></div>
				</div>
				<button class="screenshot-modal-nav screenshot-modal-next" aria-label="Next">
					<div class="icon"><i data-lucide="chevron-right"></i></div>
				</button>
			</div>
		`;
		document.body.appendChild(modalEl);

		// Initialize Lucide icons if available
		if (typeof initLucide === 'function') {
			initLucide();
		}

		return modalEl;
	}

	// Update counter display
	function updateCounter() {
		if (!modal || allImages.length <= 1) return;
		const counter = modal.querySelector('.screenshot-modal-counter');
		if (counter) {
			counter.textContent = `${currentIndex + 1} / ${allImages.length}`;
		}
	}

	// Update navigation visibility
	function updateNavigation() {
		if (!modal) return;
		const prevBtn = modal.querySelector('.screenshot-modal-prev');
		const nextBtn = modal.querySelector('.screenshot-modal-next');
		const counter = modal.querySelector('.screenshot-modal-counter');

		if (allImages.length <= 1) {
			prevBtn.style.display = 'none';
			nextBtn.style.display = 'none';
			counter.style.display = 'none';
		} else {
			prevBtn.style.display = '';
			nextBtn.style.display = '';
			counter.style.display = '';
		}
	}

	// Show image at index
	function showImage(index) {
		if (!modal || allImages.length === 0) return;

		// Wrap around
		if (index < 0) index = allImages.length - 1;
		if (index >= allImages.length) index = 0;

		currentIndex = index;
		const img = modal.querySelector('.screenshot-modal-image');
		img.src = allImages[currentIndex].src;
		img.alt = allImages[currentIndex].alt;

		updateCounter();
	}

	// Navigate to previous image
	function showPrevious() {
		showImage(currentIndex - 1);
	}

	// Navigate to next image
	function showNext() {
		showImage(currentIndex + 1);
	}

	// Open modal with image
	function openModal(imageSrc, imageAlt) {
		if (!modal) {
			modal = createModal();
		}

		// Collect images and find current index
		collectImages();
		currentIndex = allImages.findIndex(img => img.src === imageSrc);
		if (currentIndex === -1) currentIndex = 0;

		const img = modal.querySelector('.screenshot-modal-image');
		img.src = imageSrc;
		img.alt = imageAlt || '';

		updateNavigation();
		updateCounter();

		modal.classList.add('is-open');
		document.body.style.overflow = 'hidden';
	}

	// Close modal
	function closeModal() {
		if (modal) {
			modal.classList.remove('is-open');
			document.body.style.overflow = '';
		}
	}

	// Handle zoom button clicks
	document.addEventListener('click', function(e) {
		const zoomBtn = e.target.closest('.btn-screenshot');
		if (zoomBtn) {
			e.preventDefault();

			// Find the card item and get the full-size image
			const cardItem = zoomBtn.closest('.card-item');
			if (cardItem) {
				const img = cardItem.querySelector('.card-image img');
				if (img) {
					// Get full size image URL (remove any size suffixes)
					const fullSrc = img.dataset.fullSrc || img.src;
					const alt = img.alt;
					openModal(fullSrc, alt);
				}
			}
		}

		// Close modal on backdrop or close button click
		if (e.target.classList.contains('screenshot-modal-backdrop') ||
		    e.target.closest('.screenshot-modal-close')) {
			closeModal();
		}

		// Previous button click
		if (e.target.closest('.screenshot-modal-prev')) {
			showPrevious();
		}

		// Next button click
		if (e.target.closest('.screenshot-modal-next')) {
			showNext();
		}
	});

	// Keyboard navigation
	document.addEventListener('keydown', function(e) {
		if (!modal || !modal.classList.contains('is-open')) return;

		switch (e.key) {
			case 'Escape':
				closeModal();
				break;
			case 'ArrowLeft':
				e.preventDefault();
				showPrevious();
				break;
			case 'ArrowRight':
				e.preventDefault();
				showNext();
				break;
		}
	});
}

// Video Players
function initVideoPlayers() {
	const videoPreviews = document.querySelectorAll('.video-preview');

	videoPreviews.forEach(preview => {
		const container = preview.closest('.video-container');
		if (!container) return;

		const iframeContainer = container.querySelector('.video-iframe-container');
		const iframe = iframeContainer?.querySelector('iframe');

		// Support both video ID (video block) and video URL (text-image block)
		const videoId = preview.dataset.videoId;
		const videoUrl = preview.dataset.videoUrl;

		if (!iframe || (!videoId && !videoUrl)) return;

		preview.addEventListener('click', function() {
			let embedUrl;

			if (videoId) {
				// Video block: Build YouTube embed URL from ID
				embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
			} else if (videoUrl) {
				// Text-image block: Use provided URL and add autoplay parameter
				const separator = videoUrl.includes('?') ? '&' : '?';
				embedUrl = videoUrl + separator + 'autoplay=1&rel=0';
			}

			iframe.src = embedUrl;
			preview.style.display = 'none';
			iframeContainer.style.display = 'block';
		});
	});
}

// Generic Tabs
function initTabs() {
	const tabContainers = document.querySelectorAll('.tab-container');

	tabContainers.forEach(container => {
		const tabButtons = container.querySelectorAll('.btn-tabs[data-tab-target]');

		if (tabButtons.length === 0) {
			return;
		}

		// Find the content container - either sibling or within same container
		const contentContainer = container.nextElementSibling?.classList.contains('tabs-content')
			? container.nextElementSibling
			: container.querySelector('.tabs-content');

		if (!contentContainer) return;

		tabButtons.forEach(button => {
			button.addEventListener('click', function() {
				const targetId = this.dataset.tabTarget;
				const targetPanel = contentContainer.querySelector('#' + targetId);

				if (!targetPanel) return;

				// Deactivate all tabs and panels
				tabButtons.forEach(btn => {
					btn.classList.remove('active');
					btn.setAttribute('aria-selected', 'false');
				});

				const allPanels = contentContainer.querySelectorAll('.tabs-item[role="tabpanel"]');
				allPanels.forEach(panel => {
					panel.classList.remove('active');
					panel.style.display = 'none';
				});

				// Activate clicked tab and panel
				this.classList.add('active');
				this.setAttribute('aria-selected', 'true');
				targetPanel.classList.add('active');
				targetPanel.style.display = 'block';

				// Dispatch custom event for components that need to recalculate after tab switch
				targetPanel.dispatchEvent(new CustomEvent('tab:shown', { bubbles: true }));
			});
		});
	});
}

// Steps Tracker
function initStepsTracker() {
	const allTrackers = document.querySelectorAll('.steps-tracker');

	if (allTrackers.length === 0) {
		return;
	}

	let trackerDataArray = [];
	let ticking = false;
	let resizeTimer;

	// Initialize all trackers
	function init() {
		trackerDataArray = Array.from(allTrackers).map(tracker => ({
			element: tracker,
			progressInner: tracker.querySelector('.steps-tracker-progress-inner'),
			labels: Array.from(tracker.querySelectorAll('.steps-tracker-label')),
			items: Array.from(tracker.querySelectorAll('.steps-tracker-item'))
		}));

		computeMeasurements();
		updateAllTrackers();
	}

	// Calculate all measurements
	function computeMeasurements() {
		const viewportCenter = window.innerHeight / 2;

		trackerDataArray.forEach(data => {
			const trackerRect = data.element.getBoundingClientRect();
			const trackerTop = trackerRect.top + window.scrollY;

			// Calculate label positions relative to tracker
			const labelData = data.labels.map(label => {
				// Get absolute position of label
				const labelRect = label.getBoundingClientRect();
				const labelAbsoluteTop = labelRect.top + window.scrollY;
				// Calculate position relative to tracker
				const labelRelativeTop = labelAbsoluteTop - trackerTop;

				return {
					element: label,
					topY: labelRelativeTop
				};
			});

			// Get max height from last label's center position
			const lastLabel = data.labels[data.labels.length - 1];
			let maxHeight = 0;
			if (lastLabel) {
				const lastLabelRect = lastLabel.getBoundingClientRect();
				const lastLabelAbsoluteTop = lastLabelRect.top + window.scrollY;
				const lastLabelRelativeTop = lastLabelAbsoluteTop - trackerTop;
				// Set maxHeight to center of last label so it can be activated
				maxHeight = lastLabelRelativeTop + (lastLabel.offsetHeight / 2);
			}

			// Store computed data
			Object.assign(data, {
				viewportCenter,
				trackerTop,
				labelData,
				maxHeight
			});
		});
	}

	// Update a single tracker
	function updateTracker(data) {
		if (!data.progressInner) {
			return;
		}

		const scrollY = window.scrollY;
		const distanceFromTop = (scrollY + data.viewportCenter) - data.trackerTop;
		const height = Math.max(0, Math.min(distanceFromTop, data.maxHeight));

		// Update progress bar height
		data.progressInner.style.height = height + 'px';

		// Update active labels
		data.labelData.forEach((labelInfo, index) => {
			// First label is active as soon as tracker enters viewport
			const isActive = index === 0
				? height > 0
				: height >= labelInfo.topY;
			labelInfo.element.classList.toggle('active', isActive);
		});
	}

	// Update all trackers
	function updateAllTrackers() {
		trackerDataArray.forEach(updateTracker);
		ticking = false;
	}

	// Scroll handler with requestAnimationFrame
	function onScroll() {
		if (!ticking) {
			window.requestAnimationFrame(updateAllTrackers);
			ticking = true;
		}
	}

	// Resize handler with debounce
	function onResize() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			computeMeasurements();
			updateAllTrackers();
		}, 250);
	}

	// Attach event listeners
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize, { passive: true });

	// Listen for tab changes to recalculate measurements
	document.addEventListener('tab:shown', function() {
		// First remove all active classes to prevent flash
		trackerDataArray.forEach(data => {
			data.labels.forEach(label => label.classList.remove('active'));
			if (data.progressInner) {
				data.progressInner.style.height = '0px';
			}
		});

		// Then recalculate after DOM has updated
		requestAnimationFrame(() => {
			computeMeasurements();
			updateAllTrackers();
		});
	});

	// Initialize
	init();
}

// Search Bar Toggle
function initSearch() {
	const searchButton = document.getElementById('header-search');
	const searchButtonMobile = document.getElementById('header-search-mobile');
	const searchBar = document.getElementById('search-bar');
	const searchInput = searchBar?.querySelector('input[name="s"]');

	if ((!searchButton && !searchButtonMobile) || !searchBar) return;

	function toggleSearch(e) {
		e.preventDefault();
		e.stopPropagation();

		const isOpen = document.body.classList.contains('search-open');

		if (isOpen) {
			document.body.classList.remove('search-open');
		} else {
			document.body.classList.add('search-open');
			// Focus the input field and select text
			if (searchInput) {
				setTimeout(() => {
					searchInput.focus();
					searchInput.select();
				}, 100);
			}
		}
	}

	if (searchButton) {
		searchButton.addEventListener('click', toggleSearch);
	}
	if (searchButtonMobile) {
		searchButtonMobile.addEventListener('click', toggleSearch);
	}

	// Close search bar when clicking outside
	document.addEventListener('click', function(e) {
		const clickedInsideSearch = searchBar.contains(e.target);
		const clickedButton = searchButton?.contains(e.target) || searchButtonMobile?.contains(e.target);

		if (!clickedInsideSearch && !clickedButton) {
			if (document.body.classList.contains('search-open')) {
				document.body.classList.remove('search-open');
			}
		}
	});

	// Prevent closing when clicking inside search bar
	searchBar.addEventListener('click', function(e) {
		e.stopPropagation();
	});

	// Close search bar on ESC key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && document.body.classList.contains('search-open')) {
			document.body.classList.remove('search-open');
		}
	});

	// Close button
	const closeButton = searchBar.querySelector('.search-bar-close');
	if (closeButton) {
		closeButton.addEventListener('click', function() {
			document.body.classList.remove('search-open');
		});
	}
}

// Modalbox
function initModalbox() {
	function openModalbox(modal) {
		modal.classList.add('is-open');
		document.documentElement.classList.add('overflow-hidden');
		document.body.classList.add('overflow-hidden');

		// Initialize Lucide icons if present
		if (typeof initLucide === 'function') {
			initLucide();
		}
	}

	function closeModalbox(modal) {
		modal.classList.remove('is-open');
		document.documentElement.classList.remove('overflow-hidden');
		document.body.classList.remove('overflow-hidden');
	}

	// Open modal when clicking a trigger (link or button)
	document.addEventListener('click', function(e) {
		// Check for button with data-modalbox attribute
		const buttonTrigger = e.target.closest('[data-modalbox]');
		if (buttonTrigger) {
			const targetId = buttonTrigger.getAttribute('data-modalbox');
			const modal = document.getElementById(targetId);

			if (modal && modal.classList.contains('modalbox-wrap')) {
				e.preventDefault();
				openModalbox(modal);
			}
			return;
		}

		// Check for link with href pointing to modalbox
		const linkTrigger = e.target.closest('a[href^="#"]');
		if (linkTrigger) {
			const targetId = linkTrigger.getAttribute('href');
			const modal = document.querySelector(targetId + '.modalbox-wrap');

			if (modal) {
				e.preventDefault();
				openModalbox(modal);
			}
		}

		// Close modal when clicking close button
		const closeBtn = e.target.closest('.modalbox-close');
		if (closeBtn) {
			const modal = closeBtn.closest('.modalbox-wrap');
			if (modal) {
				closeModalbox(modal);
			}
			return;
		}

		// Close modal when clicking backdrop
		if (e.target.classList.contains('modalbox-wrap') && e.target.classList.contains('is-open')) {
			closeModalbox(e.target);
		}
	});

	// Close on ESC key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			const openModal = document.querySelector('.modalbox-wrap.is-open');
			if (openModal) {
				closeModalbox(openModal);
			}
		}
	});
}

/**
 * Search Autocomplete
 */
function initSearchAutocomplete() {
	const searchInputs = document.querySelectorAll('.search-form input[name="s"]');

	searchInputs.forEach(input => {
		let debounceTimer;
		let currentIndex = -1;

		// Dropdown erstellen
		const dropdown = document.createElement('ul');
		dropdown.className = 'search-autocomplete';
		dropdown.setAttribute('role', 'listbox');
		dropdown.setAttribute('aria-label', (window.caigosI18n?.searchSuggestions) || 'Suchvorschläge');
		input.parentNode.style.position = 'relative';
		input.parentNode.appendChild(dropdown);

		// ARIA für Input
		input.setAttribute('role', 'combobox');
		input.setAttribute('aria-autocomplete', 'list');
		input.setAttribute('aria-expanded', 'false');

		// Input Event
		input.addEventListener('input', (e) => {
			clearTimeout(debounceTimer);
			const term = e.target.value.trim();
			currentIndex = -1;

			if (term.length < 2) {
				hideAutocompleteDropdown(dropdown, input);
				return;
			}

			debounceTimer = setTimeout(async () => {
				const form = input.closest('form');
				try {
					form?.classList.add('loading');
					const lang = (document.documentElement.lang || '').slice(0, 2);
					const res = await fetch(`/wp-json/caigos/v1/autocomplete?term=${encodeURIComponent(term)}${lang ? `&lang=${encodeURIComponent(lang)}` : ''}`);
					const results = await res.json();
					renderAutocompleteDropdown(dropdown, results, term, input);
				} catch (err) {
					console.error('Autocomplete error:', err);
				} finally {
					form?.classList.remove('loading');
				}
			}, 300);
		});

		// Keyboard Navigation
		input.addEventListener('keydown', (e) => {
			const items = dropdown.querySelectorAll('li');
			if (items.length === 0) return;

			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault();
					currentIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
					updateAutocompleteActiveItem(items, currentIndex);
					break;

				case 'ArrowUp':
					e.preventDefault();
					currentIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
					updateAutocompleteActiveItem(items, currentIndex);
					break;

				case 'Enter':
					if (currentIndex >= 0 && items[currentIndex]) {
						e.preventDefault();
						input.value = items[currentIndex].dataset.title;
						input.closest('form').submit();
					}
					break;

				case 'Escape':
					hideAutocompleteDropdown(dropdown, input);
					currentIndex = -1;
					break;
			}
		});

		// Schließen bei Click außerhalb
		document.addEventListener('click', (e) => {
			if (!input.contains(e.target) && !dropdown.contains(e.target)) {
				hideAutocompleteDropdown(dropdown, input);
				currentIndex = -1;
			}
		});

		// Focus verloren
		input.addEventListener('blur', (e) => {
			setTimeout(() => {
				if (!dropdown.contains(document.activeElement)) {
					hideAutocompleteDropdown(dropdown, input);
				}
			}, 150);
		});
	});
}

function renderAutocompleteDropdown(dropdown, results, searchTerm, input) {
	dropdown.innerHTML = '';

	if (results.length === 0) {
		const form = input.closest('form');
		const noResultsText = form?.dataset.noResults || 'No suggestions found. Press Enter to search anyway.';

		// Kein Tracking der Autocomplete-Vorschläge: nur echte Suchen (Ergebnisseite)
		// werden als website_search erfasst. Autocomplete = Tippen, kein Suchvorgang.

		const li = document.createElement('li');
		li.className = 'no-results';
		li.setAttribute('role', 'option');
		li.setAttribute('aria-disabled', 'true');
		li.textContent = noResultsText;
		dropdown.appendChild(li);

		dropdown.classList.add('active');
		input.setAttribute('aria-expanded', 'true');
		return;
	}

	results.forEach((item) => {
		const li = document.createElement('li');
		li.setAttribute('role', 'option');
		li.setAttribute('aria-selected', 'false');
		li.dataset.title = item.title;

		// Text mit Highlighting
		li.innerHTML = highlightAutocompleteMatch(item.title, searchTerm);

		li.addEventListener('click', () => {
			input.value = item.title;
			input.closest('form').submit();
		});

		li.addEventListener('mouseenter', () => {
			const items = dropdown.querySelectorAll('li');
			items.forEach(i => {
				i.classList.remove('active');
				i.setAttribute('aria-selected', 'false');
			});
			li.classList.add('active');
			li.setAttribute('aria-selected', 'true');
		});

		dropdown.appendChild(li);
	});

	dropdown.classList.add('active');
	input.setAttribute('aria-expanded', 'true');
}

function highlightAutocompleteMatch(text, searchTerm) {
	if (!searchTerm) return escapeAutocompleteHtml(text);

	const regex = new RegExp(`(${escapeAutocompleteRegex(searchTerm)})`, 'gi');
	return escapeAutocompleteHtml(text).replace(regex, '<mark>$1</mark>');
}

function escapeAutocompleteHtml(text) {
	const div = document.createElement('div');
	div.textContent = text;
	return div.innerHTML;
}

function escapeAutocompleteRegex(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function updateAutocompleteActiveItem(items, index) {
	items.forEach((item, i) => {
		if (i === index) {
			item.classList.add('active');
			item.setAttribute('aria-selected', 'true');
			item.scrollIntoView({ block: 'nearest' });
		} else {
			item.classList.remove('active');
			item.setAttribute('aria-selected', 'false');
		}
	});
}

function hideAutocompleteDropdown(dropdown, input) {
	dropdown.classList.remove('active');
	dropdown.innerHTML = '';
	input.setAttribute('aria-expanded', 'false');
}

// Filter Drawer (Mobile)
function initFilterDrawer() {
	const toggle = document.querySelector('.filter-drawer-toggle');
	const drawer = document.getElementById('filter-drawer');
	const overlay = document.querySelector('.filter-drawer-overlay');
	const closeBtn = document.querySelector('.filter-drawer-close');

	if (!drawer || !toggle) return;

	function openDrawer() {
		drawer.classList.add('is-open');
		overlay?.classList.add('is-visible');
		document.body.classList.add('filter-drawer-open');

		// Initialize Lucide icons if present
		if (typeof initLucide === 'function') {
			initLucide();
		}
	}

	function closeDrawer() {
		drawer.classList.remove('is-open');
		overlay?.classList.remove('is-visible');
		document.body.classList.remove('filter-drawer-open');
	}

	function isOpen() {
		return drawer.classList.contains('is-open');
	}

	toggle.addEventListener('click', openDrawer);
	closeBtn?.addEventListener('click', closeDrawer);
	overlay?.addEventListener('click', closeDrawer);

	// Close on Escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && isOpen()) {
			closeDrawer();
		}
	});

	// Close when resizing to desktop
	window.addEventListener('resize', function() {
		if (window.innerWidth >= 768 && isOpen()) {
			closeDrawer();
		}
	});
}

// Mobile Language Switcher Toggle
function initMobileLangSwitcher() {
	const langSwitchers = document.querySelectorAll('.mobile-header-actions .lang-switcher');

	langSwitchers.forEach(switcher => {
		const currentLang = switcher.querySelector('.current-lang');
		const subMenu = switcher.querySelector('.sub-menu');

		if (!currentLang || !subMenu) return;

		// Toggle on click (mobile only)
		currentLang.addEventListener('click', function(e) {
			// Only handle on mobile (desktop uses hover)
			if (window.innerWidth >= 1024) return;

			e.preventDefault();
			e.stopPropagation();

			// Close other open lang switchers
			document.querySelectorAll('.lang-switcher.open').forEach(other => {
				if (other !== switcher) {
					other.classList.remove('open');
				}
			});

			switcher.classList.toggle('open');
		});
	});

	// Close when clicking outside
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.lang-switcher')) {
			document.querySelectorAll('.lang-switcher.open').forEach(switcher => {
				switcher.classList.remove('open');
			});
		}
	});

	// Close when resizing to desktop
	window.addEventListener('resize', function() {
		if (window.innerWidth >= 1024) {
			document.querySelectorAll('.lang-switcher.open').forEach(switcher => {
				switcher.classList.remove('open');
			});
		}
	});
}

// Empty Hero Links Fallback
function initEmptyHeroLinks() {
	const hero = document.querySelector('.hero');
	if (!hero) return;

	// Finde alle Buttons im Hero ohne gültigen Link
	const buttons = hero.querySelectorAll('.wp-block-button__link, .btn');
	const emptyButtons = Array.from(buttons).filter(btn => {
		const href = btn.getAttribute('href');
		return !href || href === '' || href === '#';
	});

	if (emptyButtons.length === 0) return;

	// Fallback 1: #kontakt Section
	const kontaktSection = document.getElementById('kontakt');
	if (kontaktSection) {
		emptyButtons.forEach(btn => btn.setAttribute('href', '#kontakt'));
		return;
	}

	// Fallback 2: Nächstes Element nach dem Hero (ID setzen falls nötig)
	const heroSection = hero.closest('section');
	const nextElement = heroSection?.nextElementSibling;

	if (nextElement) {
		if (!nextElement.id) {
			nextElement.id = 's1';
		}
		emptyButtons.forEach(btn => btn.setAttribute('href', '#' + nextElement.id));
	}
}

// GTM dataLayer Tracking
var gtmTrackingInitialized = false;

function initGtmTracking() {
	if (gtmTrackingInitialized) {
		return;
	}
	gtmTrackingInitialized = true;

	document.addEventListener('click', function(e) {
		if (!(e.target instanceof Element)) {
			return;
		}

		var trackEl = e.target.closest('[data-track-event]');
		if (!trackEl) {
			return;
		}

		var data = {
			event: trackEl.dataset.trackEvent,
			page_location: window.location.href
		};

		// Alle data-track-* Attribute auslesen
		for (var key in trackEl.dataset) {
			if (key === 'trackEvent') {
				continue;
			}

			if (key.startsWith('trackJson')) {
				// data-track-json-xxx → JSON parsen (für Arrays)
				var jsonProp = key.slice('trackJson'.length);
				jsonProp = jsonProp.charAt(0).toLowerCase() + jsonProp.slice(1);
				try {
					data[camelToSnake(jsonProp)] = JSON.parse(trackEl.dataset[key]);
				} catch (err) {
					data[camelToSnake(jsonProp)] = [];
				}
			} else if (key.startsWith('track')) {
				// data-track-xxx → String
				var prop = key.slice('track'.length);
				prop = prop.charAt(0).toLowerCase() + prop.slice(1);
				data[camelToSnake(prop)] = trackEl.dataset[key];
			}
		}

		// Modifier-Klicks (Cmd/Ctrl/Shift/Middle-Click) nicht abfangen
		var isModifiedClick = e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1;

		// Link ermitteln
		var link = trackEl.tagName === 'A' ? trackEl : trackEl.closest('a');

		// Speziallinks (mailto, tel, etc.) oder target="_blank" nicht verzögern
		var isSpecialLink = link && (
			/^(mailto|tel|javascript):/.test(link.href) ||
			link.hasAttribute('download') ||
			link.target === '_blank'
		);

		if (link && link.href && !isModifiedClick && !isSpecialLink) {
			// Normaler Link-Klick: Navigation verzögern bis GTM verarbeitet hat
			e.preventDefault();
			var navigated = false;
			var navigate = function() {
				if (navigated) {
					return;
				}
				navigated = true;
				window.location.href = link.href;
			};

			data.eventCallback = navigate;
			data.eventTimeout = 300;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(data);

			// Safety timeout falls GTM nicht geladen oder eventCallback nicht feuert
			setTimeout(navigate, 350);
		} else {
			// Modifier-Klicks, Speziallinks, Nicht-Links: nur pushen, nicht blockieren
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(data);
		}
	});
}

function camelToSnake(str) {
	return str.replace(/[A-Z]/g, function(letter) {
		return '_' + letter.toLowerCase();
	});
}

// Katalog-Einstieg: einmal pro Session beim ersten Eintritt in den Produktkatalog-Bereich
function initCatalogEntry() {
	// Explizit markierte Einstiegs-Links (z.B. CTA) für die Quellen-Zuordnung merken.
	// Verwendung: <a href="/produkte/..." data-catalog-entry-source="cta">
	document.addEventListener('click', function(e) {
		if (!(e.target instanceof Element)) {
			return;
		}
		var srcEl = e.target.closest('[data-catalog-entry-source]');
		if (!srcEl) {
			return;
		}
		try {
			sessionStorage.setItem('caigos_catalog_entry_source', srcEl.getAttribute('data-catalog-entry-source'));
		} catch (err) {}
	});

	var body = document.body;
	var inCatalog = body.classList.contains('post-type-product')
		|| body.classList.contains('tax-tax_product')
		|| /\/produkte(\/|$)/.test(window.location.pathname);

	if (!inCatalog) {
		return;
	}

	var STORAGE_KEY = 'caigos_catalog_entered';
	try {
		if (sessionStorage.getItem(STORAGE_KEY)) {
			return;
		}
		sessionStorage.setItem(STORAGE_KEY, '1');
	} catch (err) {
		// sessionStorage nicht verfügbar – Event würde sonst nie feuern; wir feuern dann pro Pageload
	}

	// Quelle bestimmen: markierter Klick (cta/…) > Referrer-Heuristik (navigation/direct)
	var source = '';
	try {
		source = sessionStorage.getItem('caigos_catalog_entry_source') || '';
		if (source) {
			sessionStorage.removeItem('caigos_catalog_entry_source');
		}
	} catch (err) {}

	if (!source) {
		var ref = document.referrer;
		if (!ref) {
			source = 'direct';
		} else {
			try {
				var refUrl = new URL(ref);
				source = refUrl.host === window.location.host ? 'navigation' : 'direct';
			} catch (err) {
				source = 'direct';
			}
		}
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'catalog_entry',
		content_type: 'catalog',
		catalog_entry_source: source,
		page_location: window.location.href
	});
}

// Formular-Funnel Tracking (WPForms)
var formStartFired = new WeakSet();
var formLeadFired = new WeakSet();

function getFormWrapper(el) {
	return el ? el.closest('.caigos-wpforms-container') : null;
}

function readFormTrackContext(wrapper) {
	var ctx = {};
	if (!wrapper) {
		return ctx;
	}
	for (var key in wrapper.dataset) {
		if (key.indexOf('track') !== 0 || key === 'trackEvent') {
			continue;
		}
		var prop = key.slice('track'.length);
		prop = prop.charAt(0).toLowerCase() + prop.slice(1);
		ctx[camelToSnake(prop)] = wrapper.dataset[key];
	}
	return ctx;
}

function pushFormEvent(event, ctx) {
	var data = Object.assign({ event: event }, ctx, { page_location: window.location.href });
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
}

function initFormTracking() {
	var CONFIRMATION_SELECTOR = '.wpforms-confirmation-container-full, .wpforms-confirmation-container';

	// form_start: erster Fokus in ein Formularfeld (einmal pro Formular)
	document.addEventListener('focusin', function(e) {
		if (!(e.target instanceof Element)) {
			return;
		}
		var field = e.target.closest('.wpforms-form input, .wpforms-form select, .wpforms-form textarea');
		if (!field) {
			return;
		}
		var form = field.closest('.wpforms-form');
		if (!form || formStartFired.has(form)) {
			return;
		}
		formStartFired.add(form);
		pushFormEvent('form_start', readFormTrackContext(getFormWrapper(form)));
	});

	// form_submit: Absendeversuch (unabhängig vom Ergebnis)
	document.addEventListener('submit', function(e) {
		var form = e.target;
		if (!(form instanceof Element) || !form.classList.contains('wpforms-form')) {
			return;
		}
		pushFormEvent('form_submit', readFormTrackContext(getFormWrapper(form)));
	}, true);

	// generate_lead: nur bei echtem Erfolg + vorhandenem conversion_type
	function fireLead(wrapper) {
		if (!wrapper || formLeadFired.has(wrapper)) {
			return;
		}
		var ctx = readFormTrackContext(wrapper);
		if (!ctx.conversion_type) {
			return;
		}
		formLeadFired.add(wrapper);
		pushFormEvent('generate_lead', ctx);
	}

	// a) WPForms AJAX-Erfolg (jQuery-Event)
	if (window.jQuery) {
		window.jQuery(document).on('wpformsAjaxSubmitSuccess', '.wpforms-form', function() {
			fireLead(getFormWrapper(this));
		});
	}

	// b) Bestätigungscontainer beobachten (AJAX ohne jQuery-Event + Reload)
	if ('MutationObserver' in window) {
		var observer = new MutationObserver(function(mutations) {
			for (var i = 0; i < mutations.length; i++) {
				var added = mutations[i].addedNodes;
				for (var j = 0; j < added.length; j++) {
					var node = added[j];
					if (!(node instanceof Element)) {
						continue;
					}
					var conf = node.matches(CONFIRMATION_SELECTOR)
						? node
						: node.querySelector(CONFIRMATION_SELECTOR);
					if (conf) {
						fireLead(conf.closest('.caigos-wpforms-container'));
					}
				}
			}
		});
		document.querySelectorAll('.caigos-wpforms-container').forEach(function(container) {
			observer.observe(container, { childList: true, subtree: true });
		});
	}

	// c) non-AJAX Reload: Bestätigung ist bereits im DOM
	document.querySelectorAll(CONFIRMATION_SELECTOR).forEach(function(conf) {
		fireLead(conf.closest('.caigos-wpforms-container'));
	});
}

// External Links - open in new tab
function initExternalLinks() {
	const currentHost = window.location.hostname;

	document.querySelectorAll('a[href]').forEach(link => {
		const href = link.getAttribute('href');

		// Skip empty, anchor, or javascript links
		if (!href || href.startsWith('#') || href.startsWith('javascript:')) {
			return;
		}

		try {
			const url = new URL(href, window.location.origin);

			// Check if external (different hostname)
			if (url.hostname && url.hostname !== currentHost) {
				link.setAttribute('target', '_blank');
				link.setAttribute('rel', 'noopener noreferrer');
			}
		} catch (e) {
			// Invalid URL, skip
		}
	});
}
